/**
 * The one place the UI's date format is spelled out (issue #1400).
 *
 * Every date shown to a user reads as MM/DD/YYYY. Import these instead of re-typing a format string
 * at a render site: a literal per call site is how the app ended up displaying `MMM dd, yyyy`,
 * `dd MMMM yyyy`, `dd MMM, yyyy` and a raw ISO date all at once.
 *
 * Two token dialects are in play and they are NOT interchangeable — `dd` is the day of the month in
 * date-fns and the day of the YEAR in dayjs, so a swapped pair renders a plausible-looking wrong
 * date rather than failing loudly:
 *   - date-fns (`helpers/utils.helper → formatDate`) → `DATE_FORMAT` / `DATE_TIME_FORMAT`
 *   - dayjs (Ant Design's `DatePicker` `format` prop) → `DATE_PICKER_FORMAT`
 *
 * These describe DISPLAY only. What goes to the backend stays ISO (`yyyy-MM-dd`) — see the
 * `DatePicker`'s `onChange` in `QuotationConfiguration`.
 */

/** date-fns output format for a date on its own, e.g. `06/01/2026`. */
export const DATE_FORMAT = "MM/dd/yyyy"

/**
 * date-fns output format for a date that also carries a time, e.g. `06/01/2026 14:30`. The time part
 * is unchanged from what these call sites already showed; only the date part is normalised.
 */
export const DATE_TIME_FORMAT = "MM/dd/yyyy HH:mm"

/** dayjs format for Ant Design's `DatePicker`, whose tokens differ from date-fns'. */
export const DATE_PICKER_FORMAT = "MM/DD/YYYY"

/** date-fns input format for the ISO date the backend sends (`2026-06-01`). */
export const ISO_DATE_FORMAT = "yyyy-MM-dd"
